import { FC } from 'react';

import useRouter from 'use-react-router';

// @ts-ignore
import { parse } from 'query-string';

export const EmployeeError: FC = () => {
  const {
    location: { search }
  } = useRouter();
  const { reason } = parse(search);

  return (
    <div>
      <div className="l-title-wrap" />
      <div className="l-wrap-xs">
        <div className="l-box-message">
          <p className="m-title-sub u-pt0 u-ta-c">エラーが発生しました</p>
          {reason === 'link_expired' && (
            <div>
              入力用URLが失効しました。
              <br />
              再度入力用URLを発行してください。
              <br />
            </div>
          )}
          {reason === 'request_deleted' && (
            <div>
              入力依頼が管理者により削除されました
              <br />
            </div>
          )}
          {reason === 'session_expired' && (
            <div>
              認証が切れました。
              <br />
              メールのリンクまたはジョブカン労務HR、ジョブカン給与計算から からもう一度年末調整にお入りください。
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
